import CharacterSummary from './CharacterSummary';

export default CharacterSummary;
export { CharacterSummary };
